<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">

        <div class="row">
            <div class="row">
                <div class="col-xl-12 col-md-12 col-sm-12">
                    <div class="circle pointer" @click="openModalViewStory(1)">
                        <img src="https://soul-repository.sfo3.cdn.digitaloceanspaces.com/images/Soul%20Contabilidade/soul_color.png"
                            alt="" />
                        <svg v-if="!store_one" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"
                            style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                            <circle cx="50" cy="50" r="40" />
                        </svg>
                        <svg v-else viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"
                            style="enable-background:new -580 439 577.9 194;" xml:space="preserve">
                            <circle cx="50" cy="50" r="40" style="stroke: #00a800;" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 mb-4">
                <div class="jumbotron">
                    <h1 class="display-4">Olá, {{ name }} !</h1>
                    <p class="lead">Seja muito bem-vindo(a).</p>
                    <hr class="my-4">
                    <p>Para acessar os seus diretórios e arquivos, por gentileza, clique no botão abaixo.</p>
                    <p class="lead">
                        <router-link to="client-file" class="btn btn-primary btn-lg" href="#" role="button">Acessar meus
                            documentos <i class="fa fa-arrow-right"></i></router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div id="modalDisplayStorie" class="modal" :style="{ display: modalDisplayStorie }">
        <div class="row">
            <div class="col-lg-12 col-sm-12 col-xs-12">
                <div class="modal-content modal-storie">
                    <div class="modal-header modal-header-storie">
                        <button type="button" class="close btn-white close-storie" @click="closeModalStorie()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ListStorie :id="idCarousel" v-if="loadImagesStorie"></ListStorie>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>

import Loading from 'vue-loading-overlay';
import ListStorie from '../stories/list-storie.vue';

export default {
    components: { Loading, ListStorie },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            name: '',
            store_one: false,
            store_two: false,
            viewStory: false,
            modalDisplayStorie: 'none',
            loadImagesStorie: false,
            idCarousel: 1
        }
    },
    mounted() {
        this.loadData();
        this.name = localStorage.getItem('name');
        this.isLoading = false;
        const store_one = localStorage.getItem('store_one');
        const store_two = localStorage.getItem('store_two');
        if (store_one != null) {
            this.store_one = true;
        }

        if (store_two != null) {
            this.store_two = true;
        }

    },
    methods: {
        onCancel() { },
        loadData() { },
        openModalViewStory(idCarousel) {
            this.modalDisplayStorie = 'block';
            this.read = true;
            this.idCarousel = idCarousel;
            this.loadImagesStorie = true;

            if (idCarousel == 1) {
                this.store_one = true;
                localStorage.setItem('store_one', '20260109_1');
            } else if (idCarousel == 2) {
                this.store_two = true;
                localStorage.setItem('store_two', '20260109_2');
            }
        },
        closeModalStorie() {
            this.modalDisplayStorie = 'none';
            this.loadImagesStorie = false;
        }

    }
}
</script>

<style>
.select-graph {
    width: 25% !important;
    float: right;
}


.modal-header-storie {
    border: none;
    background-color: #ffffff00;
}

.btn-white {
    color: #fff !important;
}

.btn-white:hover {
    color: #970000;
}

.modal-storie {
    margin: 0% auto!important;
    background-color: #ffffff00 !important;
    border: none !important;
}

.carousel__image {
  max-width: 100%;    /* Ensures image doesn't exceed container width */
  max-height: 100%!important;   /* Ensures image doesn't exceed container height */
  object-fit: contain; /* Scales the image nicely to fit without stretching/cropping */
  display: block;     /* Helps with centering if needed */
  margin: 0 auto;     /* Centers the image horizontally */
}

.close-storie{
    background-color: #d56363!important;
    border: 0;
}
</style>